import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachService } from 'orv-ui-base-lib';

@Component({
  selector: 'app-attachment-image-modal',
  templateUrl: './attachment-image-modal.component.html',
  styleUrls: ['./attachment-image-modal.component.scss']
})
export class AttachmentImageModalComponent implements OnInit, OnDestroy {

  @Input('id') 
  set id(value: number) {
    this._id = value;
    this.loadImage();
  }
  @Input() _id: number;
  @Input() isModal = true;
  @Input() inputstyle: string;

  @Output() attachDowloaded: EventEmitter<any> = new EventEmitter();

  file: any;

  loading: boolean = false;
  url: any;

  constructor(private modal: NgbActiveModal,
    private attachService: AttachService) { }

  ngOnInit() {
    
  }

  loadImage() {

  this.loading = true;
  this.attachService.download(this._id).subscribe(response => {
    this.file = response;
    if (response) {
      this.url = URL.createObjectURL(response);
      this.attachDowloaded.emit(this.url);
    }
    this.loading = false;
  }, () => {
    this.loading = false;
  });

  }

  ngOnDestroy() {
    if (this.url) URL.revokeObjectURL(this.url);
  }

  close() {
    this.modal.dismiss('close');
  }

}
